import { render } from "./DBLinkedData.vue?vue&type=template&id=335e45e2&scoped=true&ts=true"
import script from "./DBLinkedData.vue?vue&type=script&lang=ts"
export * from "./DBLinkedData.vue?vue&type=script&lang=ts"

import "./DBLinkedData.vue?vue&type=style&index=0&id=335e45e2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335e45e2"]])

export default __exports__